import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import logo from '../../images/header_logo.svg';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [showScamModal, setShowScamModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <header className='header' id='home'>
      <div className=''>
        <Image src={logo} fluid={true} className='logo' alt='Logo von Notarin Yvonne Luz' />

        <p className='button-wrapper'>
          <HashLink className='btn btn-primary' to='/#about'>
            Mehr erfahren
          </HashLink>
        </p>
      </div>

      <div className='d-none col-12 flex-column justify-content-center align-content-end align-items-center d-flex'>
        <div className='header-grid'>
          <div className='coronainfo-box'>
            <h2 className='coronainfo-heading'>Hinweis</h2>
            <p className='text'>
              Bitte beachten Sie, dass unser Büro am{' '}
              <span className='text-primary fw-bold'>
                Freitag, den 02. Januar 2026 sowie am Montag, den 05. Januar 2026
              </span>{' '}
              geschlossen ist.
            </p>
            <p className='coronainfo-button-wrapper hide'>
              <Button variant='outline-primary' onClick={handleShowModal}>
                Weitere Informationen
              </Button>
            </p>

            <Modal className='modal-coronainfo hide' show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Hinweise zur Coronasituation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className='modal-text'>
                  Auch wir sehen uns gezwungen, auf die Corona-Pandemie zum Schutz unserer Kunden und Mitarbeiter
                  angemessen zu reagieren.
                </p>
                <p className='modal-text'>
                  Termine bieten wir bis auf weiteres nur nach telefonischer Vereinbarung an. Beurkundungstermine können
                  nur stattfinden, sofern keiner der Beteiligten erkrankt ist oder in der Woche davor wissentlich
                  Kontakt mit einer infizierten Person hatte oder sich in Quarantäne befindet. Besprechungstermine
                  können derzeit nur telefonisch durchgeführt werden. Für alle gilt: Bitte halten Sie größtmöglichen
                  Abstand, sowohl voneinander als auch von uns und wirken Sie an den von uns ergriffenen
                  Hygienemaßnehmen aktiv mit.
                </p>
                <p className='modal-text'>
                  Wir arbeiten derzeit aus Sicherheitsgründen mit teilweise veränderten Arbeitszeiten und mit einem
                  verkleinerten Team. Bitte haben Sie daher Verständnis, wenn sich die Bearbeitungszeiten hierdurch im
                  Einzelfall verlängern können.
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='outline-primary' onClick={handleCloseModal}>
                  Schließen
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          <div className='coronainfo-box hide'>
            <h2 className='coronainfo-heading text-danger'>Warnung vor Telefonbetrug Gewinn-Nachricht</h2>
            <p className='text'>
              Aktuell bekommen wir vermehrt Hinweise, dass Betrüger sich per Telefon oder E-Mail als Mitarbeiter unserer
              Kanzlei ausgeben.
            </p>
            <p className='coronainfo-button-wrapper'>
              <Button variant='outline-danger' onClick={() => setShowScamModal(true)}>
                Weitere Informationen
              </Button>
            </p>

            <Modal className='modal-scam-info' show={showScamModal} onHide={() => setShowScamModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Warnung vor Telefonbetrug Gewinn-Nachricht</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className='modal-text'>
                  Aktuell bekommen wir vermehrt Hinweise, dass Betrüger sich per Telefon oder E-Mail als Mitarbeiter
                  unserer Kanzlei ausgeben. Sie behaupten, die Kanzlei würde einen Lotteriegewinn abwickeln und der
                  Angesprochene habe einen hohen Betrag gewonnen. Um diesen Betrag zu erhalten, müsse man vorab eine
                  Abwicklungsgebühr überweisen, i.d.R. auf ein ausländisches Konto. <br />
                  Bitte fallen Sie nicht auf diesen Trick herein, es handelt sich um Betrug. Diese Personen sind uns
                  weder bekannt, noch arbeiten sie in unserer Kanzlei. Falls Sie einen solchen Anruf erhalten, empfehlen
                  wir Ihnen, die Verbraucherzentrale und/oder die Bundesnetzagentur zu verständigen. Überweisen Sie
                  keinesfalls Geld und rufen Sie die angegebene ausländische Nummer (meist 0090 …) nicht zurück.
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='outline-danger' onClick={() => setShowScamModal(false)}>
                  Schließen
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
